// extracted by mini-css-extract-plugin
export default {"small":"Timer_small__-ySAM","medium":"Timer_medium__3G+CA","timerSeconds":"Timer_timerSeconds__L+vb6","timerSecondsStrong":"Timer_timerSecondsStrong__t7dbl"};